/**
 * Naive simple English pluralization
 */
export function pluralize(count: number, singular: string, plural: string) {
  return count === 1 ? singular : plural;
}
